/**
 * Promo "Kembali Premium + Google AI Pro" — pemalar + semakan kelayakan (sisi klien).
 *
 * ⚠️ KEMBAR: functions/promoAiPro.js (server). Ubah satu, ubah dua-dua.
 *    Salinan ini untuk PAPARAN sahaja (halaman /promo tahu apa nak tunjuk tanpa
 *    menunggu fungsi awan). Keputusan sebenar dibuat oleh server semasa bil dicipta,
 *    jadi kalau dua salinan terpesong, pelanggan nampak mesej ralat daripada server —
 *    bukan bayaran yang tersilap diterima.
 */

export const PROMO_AI_PRO_ID = 'google_ai_pro';
export const PROMO_AI_PRO_DOC = 'promo_ai_pro';      // public_stats/{doc}
export const PROMO_AI_PRO_HARI_MIN = 30;
// ⚠️ KEMBAR harga: BILLPLZ_PLANS.premium.renewSen (functions/index.js). Server yang caj.
export const PROMO_AI_PRO_RM = 99;
export const PROMO_AI_PRO_BULAN_HADIAH = 18;

const SEHARI = 24 * 60 * 60 * 1000;
const KL = 8 * 60 * 60 * 1000;
const tarikhKL = (ms) => new Date(ms + KL).toISOString().slice(0, 10);

function keMs(ts) {
    if (!ts) return null;
    if (typeof ts.toMillis === 'function') return ts.toMillis();
    if (typeof ts.seconds === 'number') return ts.seconds * 1000;
    const ms = ts instanceof Date ? ts.getTime() : new Date(ts).getTime();
    return Number.isFinite(ms) ? ms : null;
}

/** Sama tepat dengan functions/promoAiPro.js — lihat nota di sana. */
export function semakKelayakanPromoAiPro({ lesen, pesanan = [], sekarangMs = Date.now() }) {
    if (!lesen) return { layak: false, sebab: 'tiada_lesen' };

    const jenis = String(lesen.type || lesen.licType || 'monthly');
    if (jenis === 'yearly' || jenis === 'smart') return { layak: false, sebab: 'bukan_premium' };

    const sudah = (Array.isArray(pesanan) ? pesanan : []).some(
        (o) => o && o.promo === PROMO_AI_PRO_ID && (o.status === 'paid' || o.status === 'processing'),
    );
    if (sudah) return { layak: false, sebab: 'sudah_tuntut' };

    const tamatMs = keMs(lesen.expiresAt);
    if (!tamatMs) return { layak: false, sebab: 'tiada_tarikh' };
    if (tamatMs > sekarangMs) return { layak: false, sebab: 'masih_aktif', tamatMs };

    const hari = Math.round((Date.parse(tarikhKL(sekarangMs)) - Date.parse(tarikhKL(tamatMs))) / SEHARI);
    if (hari <= PROMO_AI_PRO_HARI_MIN) return { layak: false, sebab: 'belum_cukup_tempoh', tamatMs, hari };

    return { layak: true, sebab: 'layak', tamatMs, hari };
}
